import { DataFetchingState } from '../dataFetching/generators';
import { ProductImageTagType } from '../productdetail/types';

export const FETCH_CART_COUNT = 'FETCH_COUNT_CART';
export const FETCH_CART_COUNT_SUCCESS = 'FETCH_CART_COUNT_SUCCESS';
export const FETCH_CART_COUNT_FAILED = 'FETCH_CART_COUNT_FAILED';

export const CLEAR_CART = 'CLEAR_CART';

export interface CartCountResponse {
    data: {
        count: number;
    };
}

export interface CartProductItem {
    name: string;
    sku: string;
    price: string;
    originalPrice: string;
    brand: string;
    description: string;
    image: string;
    imagePath: string;
    imageTag: ProductImageTagType;
    stock: string;
    quantity: number;
    // eslint-disable-next-line camelcase
    product_image?: {
        tag: ProductImageTagType;
        path: string;
    };
}
export interface CartResponse {
    data: {
        items: CartProductItem[];
        subtotal: number;
    };
}

export type AddToCartState = Omit<DataFetchingState, 'reducerPayloadOptions'>;

export interface CartState {
    isFetching: boolean;
    didInvalidate: boolean;
    count: number;
    error?: Error | string | null;
    identifier: string;
    carts: CartProductItem[];
    subtotal?: string;
    addToCartState: AddToCartState;
}
